import React, { useEffect, useState } from "react";
import DataTable from "../common/DataTable";

const UserTableAdmin = ({ userList, selectRow }) => {
  const [open, setOpen] = useState(false);
  const [selectedRows, setSelectedRows] = selectRow;
  const [tableData, setTableData] = useState([]);

  const columns = [
    {
      label: "Email",
      field: "email",
      width: 500,
    },
  ];

  useEffect(() => {
    // Add id field for DataTable selection to work properly
    // Use _id first since the user data uses MongoDB's _id field
    const dataWithIds = userList.map((row, index) => ({
      ...row,
      id: row._id || row.id || row.email || index,
    }));
    setTableData(dataWithIds);
    setOpen(true);
  }, [userList]);

  const handleSelectionChange = (selectedItems) => {
    setSelectedRows(selectedItems);
  };

  return (
    <>
      {open && (
        <div
          className="admin-table"
          style={{ margin: "2.5rem 4rem 2rem 4rem" }}
        >
          <DataTable
            columns={columns}
            data={tableData}
            searchable={true}
            searchPlaceholder="Search"
            selectable={true}
            hover={true}
            selectedItems={selectedRows}
            onSelectionChange={handleSelectionChange}
            entries={4}
            entriesOptions={[4, 8, 12]}
            format={(field, value) => {
              if (field === "email") {
                return {
                  fontSize: "15.5px",
                };
              }
              return {};
            }}
          />
        </div>
      )}
    </>
  );
};

export default UserTableAdmin;
